import { gql } from '@parkchirp/api-client';

export const LIST_VEHICLE_MAKES = gql`
  query listVehicleMakes {
    listVehicleMakes {
      data {
        id
        name
      }
    }
  }
`;

export const LIST_VEHICLE_MODELS = gql`
  query listVehicleModels(
    $vehicleMakeId: Int!
  ) {
    listVehicleModels(
      vehicleMakeId: $vehicleMakeId
    ) {
      data {
        id
        name
      }
    }
  }
`;
